import { IonCardTitle } from '@ionic/react';

export const CardTitle: React.FC<{children: React.ReactNode}> = ({ children }) => {
    return (
        <IonCardTitle>
            {children}
        </IonCardTitle>
    );
};
